import { AdminRoleApi } from "@/api";

export async function getAll() {
  const { data } = await AdminRoleApi.getAdminRoles();
  return data;
}
